<template>
  <div
    class="c-px-1 order-2 bg-white c-lg:bg-primary-200"
  >
    <div class="navbar-secondary__imgbg embed-responsive embed-responsive-16by9 c-m-0 hidden c-lg:block">
      <ResponsiveImage
        src="mixit_plus/intro.jpg"
        img-class="embed-responsive-item image-cover"
        alt="mixit plus intro"
        sizes="(min-width: 1401px) 100vw, (min-width: 1025px) 60vw, (min-width: 769px) 70vw, 60vw"
        :lazy-load="false"
      />
    </div>
    <div class="container">
      <!-- text -->
      <div class="c-pt-2 c-pb-6 c-lg:c-pt-5 c-xl:c-pb-9 row c-justify-center">
        <div class="col-8 c-py-10 text-center position-relative">
          <div class="relative text-center">
            <!-- overlay -->
            <div class="mixit-plus-intro-text-overlay hidden c-lg:block" />
            <div class="relative z-10 c-mt-8 c-lg:c-mt-4 c-lg:c-py-6 c-lg:c-px-8">
              <MixitPlusLogoSvg class="mixit-plus-logo" />
              <p
                class="header-text c-mb-5"
                v-html="t('free_shipping')"
              />
              <router-link
                :to="{ name: 'productPath', params: { permalink: t('permalink') } }"
                class="btn btn-success c-py-3 c-px-5 font-medium c-rounded-pill"
              >
                {{ t('activate') }} {{ mixitPlusPrice }}
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- Bottom gap -->
      <div class="hidden c-lg:block c-py-8" />
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

import ResponsiveImage from '@/components/general/BaseImage.vue'
import MixitPlusLogoSvg from "@/components/svg/MixitPlusLogoSvg.vue";
import { useNavbarStore } from "@/stores/NavbarStore";
import { storeToRefs } from "pinia";
const navbarStore = useNavbarStore()

const { mixitPlusPrice } = storeToRefs(navbarStore)
const { t } = useI18n()
</script>

<style lang="scss" scoped>
.mixit-plus-intro-text-overlay {
  position: absolute;
  inset: 0;
  z-index: 0;
  border-radius: 1.5rem;
  background-color: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.mixit-plus-logo {
  max-height: 88px;
}

.header-text {
  font-size: 1.5rem;
}
</style>

<i18n>
  {
    "cs": {
    "activate": "Aktivovat Mixit plus+ za",
    "free_shipping": "<strong>Doprava zdarma</strong> na výdejní místa a <strong>lákavé slevy každý měsíc.</strong> Nakupujte <strong>pohodlně a bez starostí!</strong>",
    "permalink": "mixit-plus-na-12-mesicu"
},
    "sk": {
    "activate": "Aktivovať Mixit plus+ za",
    "free_shipping": "<strong>Doprava zdarma</strong> na výdajné miesta a<strong> lákavé zľavy každý mesiac.</strong> Nakupujte<strong> pohodlne a bez starostí!</strong>",
    "permalink": "mixit-plus-na-12-mesiacov"
},
    "pl": {
    "activate": "Aktywuj Mixit plus+ w cenie",
    "free_shipping": "<strong>Darmowa dostawa</strong> do punktów odbioru oraz <strong> atrakcyjne kuszące zniżki co miesiąc.</strong> Kupuj<strong> bez stresu i bez ograniczeń!</strong>",
    "permalink": "mixit-plus-na-12-miesiecy"
},
    "hu": {
    "activate": "Mixit plus+ aktiválása",
    "free_shipping": "<strong>Ingyenes szállítás</strong> az átvételi pontokra és <strong>csábító kedvezmények minden hónapban.</strong> Vásároljon <strong>Kényelmesen és gondtalanul!</strong>",
    "permalink": "mixit-plusz-12-honapra"
},
    "de": {
    "activate": "Aktiviere Mixit plus+ für",
    "free_shipping": "<strong>Kostenloser Versand </strong> und jeden Monat <strong> verlockende Rabatte. </strong>Shoppe<strong> bequem und sorgenfrei! </strong>",
    "permalink": "mixit-plus-fuer-12-monate"
},
    "at": {
    "activate": "Aktiviere Mixit plus+ für",
    "free_shipping": "<strong>Kostenloser Versand </strong> und jeden Monat <strong> verlockende Rabatte. </strong>Shoppe<strong> bequem und sorgenfrei! </strong>",
    "permalink": "mixit-plus-fuer-12-monate"
},
    "ro": {
    "activate": "Activați Mixit Plus+ la",
    "free_shipping": "<strong>Transport gratuit</strong> la punctele de ridicare Packeta și <strong>reduceri tentante în fiecare lună.</strong> Cumpărați <strong>comod și fără griji!</strong>",
    "permalink": "mixit-plus-de-12-luni"
},
    "fr": {
    "activate": "Activer Mixit Plus+ pour",
    "free_shipping": "<strong>Livraison gratuite </strong> en points de retrait et <strong> réductions attractives chaque mois. </strong>Faites vos achats <strong> en toute simplicité et sans souci ! </strong>",
    "permalink": "mixit-plus-pour-12-mois"
},
    "it": {
    "activate": "Attiva Mixit plus+ per",
    "free_shipping": "<strong>Spedizione gratuita</strong> nei punti di ritiro e <strong>sconti irresistibili ogni mese.</strong> Acquista <strong>in tutta comodità e senza pensieri!</strong>",
    "permalink": "mixit-plus-per-12-mesi"
}
  }
</i18n>
